import { useParams } from "react-router";
import DonsInsertForm from "../../components/Dons/DonsInsertForm";
import { useDonationsByIdQuery } from "../../stores/OkOkStore";
import { useTrads } from "../../contexts/trads/useTrads";

function DonsAdd(){
    const params = useParams();
    const { data: fond, error, isLoading } = useDonationsByIdQuery((params.id)??"0");
    const {translate}=useTrads();
    return (
        error ? <p className="p-3 mb-2 bg-danger text-white">{translate('page_load_error')}</p> :
        isLoading ? <p className="p-3 mb-2 bg-info text-white">{translate('page_loading')}</p> :
        fond && 
        <DonsInsertForm fond={fond}  ></DonsInsertForm>
    );
}
export default DonsAdd;